// src/pages/RegisterPage/RegisterPage.tsx

import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import styles from './RegisterPage.module.css'; // Usa o CSS existente ou pode criar um inline se preferir
import { API_BASE_URL } from '../../config';

const RegisterPage: React.FC = () => {
  const [displayName, setDisplayName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false); // Novo estado
  
  const navigate = useNavigate();

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ displayName, email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        // SUCESSO: Não navega, mostra estado de sucesso na tela
        setSuccess(true);
      } else {
        setError(data.error || 'Erro ao criar conta.');
      }
    } catch (err) {
      setError('Erro de conexão.');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    try {
        const res = await fetch(`${API_BASE_URL}/api/auth/google/url`);
        const data = await res.json();
        if (data.url) {
            window.location.href = data.url;
        }
    } catch (error) {
        console.error("Erro Google", error);
    }
  };

  if (success) {
      return (
          <div className={styles.pageContainer}>
             <div className={styles.formCard} style={{textAlign: 'center'}}>
                 <div style={{fontSize: '3rem', marginBottom: '15px'}}>📧</div>
                 <h2 style={{color: '#fff'}}>Verifique seu E-mail</h2>
                 <p style={{color: '#aaa', marginBottom: '25px'}}>
                     Enviamos um link de confirmação para <strong>{email}</strong>.
                     <br/>Clique no link para ativar sua conta.
                 </p>
                 <button onClick={() => navigate('/')} className={styles.submitButton}>
                     Voltar para Login
                 </button>
             </div>
          </div>
      );
  }

  return (
    <div className={styles.pageContainer}>
      <div className={styles.formCard}>
        <h2>Crie sua conta</h2>
        {error && <div className={styles.errorMessage}>{error}</div>}
        
        <form onSubmit={handleRegister}>
          <div className={styles.formGroup}>
            <label>Nome de Exibição</label>
            <input 
              className={styles.inputField}
              type="text" 
              value={displayName} 
              onChange={(e) => setDisplayName(e.target.value)} 
              placeholder="Ex: João Silva"
              required 
            />
          </div>

          <div className={styles.formGroup}>
            <label>E-mail</label>
            <input 
              className={styles.inputField}
              type="email" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
              placeholder="seu@email.com"
              required 
            />
          </div>

          <div className={styles.formGroup}>
            <label>Senha</label>
            <input 
              className={styles.inputField}
              type="password" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              placeholder="******"
              required 
            />
          </div>

          <button type="submit" disabled={loading} className={styles.submitButton}>
            {loading ? 'Criando...' : 'Cadastrar'}
          </button>
        </form>

        <div style={{textAlign: 'center', margin: '15px 0', color: '#555'}}>ou</div>

        <button type="button" onClick={handleGoogleLogin} className={styles.submitButton} style={{background: '#fff', color: '#333', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px'}}>
          <img src="https://www.svgrepo.com/show/475656/google-color.svg" alt="G" style={{width: 20}}/>
          Entrar com Google
        </button>

        <div className={styles.loginLink}>
          Já tem uma conta? <Link to="/">Entrar</Link>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;